import { FC, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { Element } from 'react-scroll';

import styles from '@components/join/join.module.scss';
import LabelInput from '@components/labelInput';
import { onInputPassword, passwordValidator, valueRequired } from '@utils/validators/validators';
import classnames from 'classnames/bind';

const cx = classnames.bind(styles);

interface IPassword {
  prefixName: string;
}

const Password: FC<IPassword> = ({ prefixName }) => {
  const {
    watch,
    register,
    formState: { errors },
  } = useFormContext();
  const passwordValue = watch(prefixName);
  const [isPwVisible, setIsPwVisible] = useState(false);
  const [email, userId] = watch(['email', 'userId']);

  const onChangeIsPwVisible = () => {
    setIsPwVisible(!isPwVisible);
  };

  return (
    <Element name={prefixName} className={cx('infoWrap')}>
      <LabelInput
        {...register(prefixName, {
          ...valueRequired,
          validate: (value: string) => passwordValidator(value, email, userId),
        })}
        type={isPwVisible ? 'text' : 'password'}
        className={cx('input', { error: errors.password, success: !errors.password })}
        placeholder={'비밀번호'}
        minLength={6}
        maxLength={16}
        onInput={onInputPassword}
        autoComplete="new-password"
        isvalue={passwordValue}
        tabIndex={6}
      />
      {errors.password && <div className={cx('infoText', 'error')}>{errors.password.message as string}</div>}
      <span className={cx('btnArea')}>
        <button
          tabIndex={-1}
          type="button"
          className={cx('btnConfirmPassword', { on: isPwVisible })}
          onClick={onChangeIsPwVisible}
        />
      </span>
    </Element>
  );
};

export default Password;
